// extracted by mini-css-extract-plugin
export default {"resultPros__prosList":"PhZGITKzsocM4E75qbHx","resultPros__prosItem":"yLkoYSOEKkTOdUkBE6RT","resultPros__prosText":"bbTEaldth3Z_Bh7bP5aK","resultPros__prosImg":"BbVv3FsdHWOx7VWkfYuW"};